import type { EditorPluginConfig, ViewerPluginConfig } from './../ricos-types';

import type { ButtonViewer } from './viewer/button-viewer';

export const LINK_BUTTON_TYPE = 'wix-draft-plugin-link-button';
export const ACTION_BUTTON_TYPE = 'wix-draft-plugin-action-button';

export interface LinkButtonPluginEditorConfig
  extends EditorPluginConfig,
    ButtonPluginEditorConfigCommon {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}
export interface LinkButtonPluginViewerConfig
  extends ViewerPluginConfig,
    ButtonPluginViewerConfigCommon {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

export interface ActionButtonPluginEditorConfig
  extends EditorPluginConfig,
    ButtonPluginEditorConfigCommon {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}
export interface ActionButtonPluginViewerConfig
  extends ViewerPluginConfig,
    ButtonPluginViewerConfigCommon {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

interface ButtonPluginViewerConfigCommon {
  colors?: {
    color1?: string; // used for default textColor
    color2?: string;
    color3?: string;
    color4?: string;
    color5?: string;
    color6?: string;
    color7?: string;
    color8?: string; // used for default border and background color
    color9?: string;
    color10?: string;
  };
}

export interface ButtonPluginEditorConfigCommon {
  colors?: {
    color1?: string; // used for default textColor
    color2?: string;
    color3?: string;
    color4?: string;
    color5?: string;
    color6?: string;
    color7?: string;
    color8?: string; // used for default border and background color
    color9?: string;
    color10?: string;
  };
  // all of the onColorAdded props should be required to ColorPicker work as intended
  onTextColorAdded?: (color: string) => string[];
  onBackgroundColorAdded?: (color: string) => string[];
  onBorderColorAdded?: (color: string) => string[];
  getTextColors?: () => string[];
  getBorderColors?: () => string[];
  getBackgroundColors?: () => string[];
  width?: string;
  text?: string;
  customComponent?: (props: React.ComponentProps<typeof ButtonViewer>) => JSX.Element;
  disableResize?: boolean;
}
